const langArr = {
  "title": {
    "en": "Alexey Demydov",
    "ua": "Олексій Демидов",
  },
  "one": {
    "en": "Ability to work efficiently both individually and in a team",
    "ua": "Вміння ефективно працювати як індивідуально, так і в команді",
  },
  "two": {
    "en": "Creative thinking skills",
    "ua": "Творче мислення",
  },
  "thre": {
    "en": "Organizational skills",
    "ua": "Організаційні навички",
  },
  "four": {
    "en": "Willingness to learn",
    "ua": "Готовність вчитися",
  },
  "five": {
    "en": "Teamwork",
    "ua": "Командний гравець",
  },
  "contacts": {
    "en": "Contacts",
    "ua": "Контакти",
  },
  "tel": {
    "en": "tel:&nbsp",
    "ua": "тел:&nbsp",
  },
  "mail": {
    "en": "mail:&nbsp",
    "ua": "пошта:&nbsp",
  },
  "soft": {
    "en": "Soft skills",
    "ua": "Особисті якості",
  },
  "tech": {
    "en": "Tech skills",
    "ua": "Технічні навички",
  },
  "educ": {
    "en": "Education",
    "ua": "Освіта",
  },
  "devel": {
    "en": "Developer",
    "ua": "Розробник",
  },
  "develop": {
    "en": "Developer",
    "ua": "Розробник",
  },
  "summ": {
    "en": "Summary",
    "ua": "Резюме",
  },
  "summText": {
    "en": "I am a front-end developer looking for a full-time job in company. I have good knowledge of HTML, CSS and JavaScript. In addition, I have practical experience of working as a team leader. I learn fast, responsible and ready for complex tasks.",
    "ua": "Я фронтенд розробник, шукаю роботу на повний робочий день у компанії. Я добре знаю HTML, CSS та JavaScript. Крім того, маю практичний досвід роботи керівником групи. Навчаюсь швидко, відповідальний та готовий до складних завдань.",
  },
  "proj": {
    "en": "Project experience:",
    "ua": "Портфоліо:",
  },
  "btnSendMe": {
    "en": "send me",
    "ua": "Написати мені",
  },
  "modalTitle": {
    "en": "This is a working mod, you can contact me",
    "ua": "Це робоча модалка, Ви зможете зв'язатись зі мною",
  },
  "follow": {
    "en": "follow me",
    "ua": "Зв'язатися зі мною",
  },
  "btnSend": {
    "en": "send",
    "ua": "Відправити",
  },
  "date": {
    "en": "Apr 2022- present",
    "ua": "Квітень 2022- дотепер",
  },
  "vuz": {
    "en": "T.H. SHEVCHENKO NATIONAL UNIVERSITY CHERNIHIV COLEHIUM (NUCHK)",
    "ua": "Національний університет Чернігівський колегіум імені Т.Г. Шевченка",
  },
  "fak": {
    "en": "Faculty of Physics and Mathematics, specialty: mathematics and informatics | Sep 2019 - present",
    "ua": "Фізико-математичний факультет, спеціальність: математика-інформатика | Вересень 2019 - дотепер",
  },
  "country": {
    "en": "Chernihiv, Ukraine",
    "ua": "Чернігів, Україна",
  },
  "eng": {
    "en": "English - Pre-Intermediate",
    "ua": "Англійська - Нижче за середній",
  },
  "ukr": {
    "en": "Ukrainian - Native",
    "ua": "Українська - Рідна",
  },
  "rus": {
    "en": "Russian - Advanced",
    "ua": "Російська - Просунутий",
  },
  "pdf": {
    "en": "download resume PDF",
    "ua": "завантажити резюме PDF",
  },
};
